import { useTranslation } from 'react-i18next';

export default function Disclaimer() {
  const { t } = useTranslation();
  return (
    <section className="bg-bg border-t border-border">
      <div className="mx-auto max-w-3xl px-5 py-10 text-center">
        <p className="text-[12px] leading-[1.6] text-muted">
          {t('disclaimer.text')}
        </p>
      </div>
    </section>
  );
}
